import styled from 'styled-components';

export const Select = styled.select`
  font-size: 14px;
  color: var(--text);
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: none;
  border-radius: 10px;
  transition: all 0.2s;
  @media (hover: hover) {
    &:hover {
      color: var(--accent);
    }
  }
`;
